module.exports = __webpack_public_path__ + "images/avatars/female/19.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/19.svg
// module id = Fa/p
// module chunks = 154